import React from "react";

import { useFormikContext } from "formik";
import { FaqQuestionPrefixEnum, NoOfFaqEnum, SourceEnum } from "../../../../enums/template";
import { Template } from "../../../../models";

import SwitchContainer from "../common/SwitchContainer";

export default function IncludeFAQToggle() {
  const { values, setFieldValue } = useFormikContext<Partial<Template>>();

  return (
    <SwitchContainer
      title="Include FAQs"
      tooltip='Add a "Frequently Asked Questions" section to the bottom of the article.'
      enabled={Boolean(values?.includeFaq)}
      setEnabled={() => {
        setFieldValue("includeFaq", !values?.includeFaq);
        if (!values?.includeFaq && !values.faqQuestionPrefixId) {
          setFieldValue("faqQuestionPrefixId", FaqQuestionPrefixEnum.Q_LETTER);
        }
        if (!values?.includeFaq && !values.faqCount) {
          // Top X / Best X: 6 by default (the feedback asks for 5 to 8 questions)
          const isItemsArticle =
            values.sourceId === SourceEnum.TOP_ITEMS ||
            values.sourceId === SourceEnum.BEST_ITEMS;
          setFieldValue(
            "faqCount",
            isItemsArticle ? NoOfFaqEnum.SIX : NoOfFaqEnum.THREE,
          );
        }
      }}
    />
  );
}
